import { ConfigApi } from '@backstage/core-plugin-api';

// Reads the comma-separated featureFlags.enabledPlugins app-config key
// (sourced from the ENABLED_PLUGINS GitHub Environment variable, forwarded
// into the build by backstage-workflows' deploy.yaml) and checks whether the
// given plugin id is in it. Shared by every page this plugin exposes, so one
// flag governs the whole feature — not just its nav entry.
export function isPluginEnabled(
  configApi: ConfigApi,
  pluginId: string,
): boolean {
  return (configApi.getOptionalString('featureFlags.enabledPlugins') ?? '')
    .split(',')
    .map(id => id.trim())
    .filter(Boolean)
    .includes(pluginId);
}
